import { checkAccess } from 'app/actions/app.actions';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { isChainHeadSelector, isSuperChainSelector } from 'selectors';
import * as api from 'dashboard/resources/earnings.api';
import template from './earnings-widget.html';

const EARNINGS_HISTORY_PERMISSION = 'earnings.history';

const mapStateToThis = ({ session, dictionary }) => {
  const { locale, retailer } = session;
  const isSuperChain = isSuperChainSelector({ session });
  const isChainHead = isChainHeadSelector({ session });
  const terms = dictionary.terms[locale];

  return {
    retailer,
    isSuperChain,
    isChainHead,
    terms,
  };
};

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', 'gettextCatalog', '$state')
class EarningsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.activeTabIdx = 0;
    this.isHistoryLinkVisible = (!this.isSuperChain || this.isChainHead) && this.checkAccess(EARNINGS_HISTORY_PERMISSION);
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.isYear = false;
    this.loadDataAsync(() => api.fetchEarnings(retailerId), this.transformData.bind(this));
  }

  $onDestroy() {
    this.unsubscribe();
  }

  transformData(data) {
    this.createTabs(data);
    this.onChangePeriodYear(this.isYear)
    return this.tabs;
  }

  createTabs(data) {
    this.tabs = [
      this.generateTab(this.findDataItem(data, 'WTD'), 'WTD', this.gettextCatalog.getString('Week to Date Total Earnings')),
      this.generateTab(this.findDataItem(data, 'MTD'), 'MTD', this.gettextCatalog.getString('Month to Date Total Earnings')),
      this.generateTab(this.findDataItem(data, 'QTD'), 'QTD', this.gettextCatalog.getString('Quarter to Date Total Earnings')),
      this.generateTab(this.findDataItem(data,'YTD'), 'YTD', this.gettextCatalog.getString('Year to Date Total Earnings')),
    ];
  }

  findDataItem(data, periodType) {
    return data.find((item) => item.periodType === periodType);
  }

  generateTab(dataItem, periodType, title) {
    return {
    title,
    tabTitle: periodType,
    total: dataItem ? dataItem.earningsTotal : 0,
    deltaPeriod: dataItem ? dataItem.earningsDeltaPeriod : 0,
    deltaYear: dataItem ? dataItem.earningsDeltaYear : 0,
    deltaAsPercPeriod: dataItem ? dataItem.deltaAsPercPeriod : false,
    deltaAsPercYear: dataItem ? dataItem.deltaAsPercYear : false,
    };
  }

  onChangePeriodYear(isYear) {
    this.isYear = isYear;
    if (isYear)
    {
      this.delta = this.tabs[this.activeTabIdx].deltaYear;
      this.deltaAsPerc = this.tabs[this.activeTabIdx].deltaAsPercYear;
    }
    else
    {
      this.delta = this.tabs[this.activeTabIdx].deltaPeriod;
      this.deltaAsPerc = this.tabs[this.activeTabIdx].deltaAsPercPeriod;
    }
  }
}

export default class EarningsWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = EarningsWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/earnings/earnings-widget-component.js